module.exports = __webpack_public_path__ + "static/media/mockup-srodek.edf1931d.jpg";